import {
  Action_GetDMCustomers,
  Action_GetDMCustomersSuccess,
  Action_SaveCustomers,
  Action_SaveCustomersSuccess,
  Action_SaveCustomersFailed,
  Action_GetCustomerByIdAndDebt,
  Action_GetCustomerByIdAndDebtSuccess,
  Action_GetDMNhomCustomers,
  Action_GetDMNhomCustomersSuccess,
  Action_DeleteCustomers,
  Action_DeleteCustomersSuccess,
  Action_DeleteCustomersFailed
} from "actions/DanhMuc/DanhMucKhachHang/actionTypes";

const initialState = {
  objCustomer: {},
  objNhomCustomer: {},
  objDataCustomer: {List:[]},
  disabledKhachHangClick: false,
  isOkGetDMKhachHang: false,
  isSaveOk: false,
  objData: {},
  showPopup: false,
  iStatus: 0,
  iLoadDanhSach : 0,
  isProgress: false
};
////////////////////////

const Reducer_GetCustomerById = (state, action) => ({
  ...state,
  objCustomer: {},
});
const Reducer_GetCustomerByIdSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objCustomer: action.payload,
  };
};
// danh mục Customers
const Reducer_GetDMCustomers = (state, action) => ({
  ...state,
  isOkGetDMKhachHang: false,
  isProgress: true
});
const Reducer_GetDMCustomersSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objDataCustomer: action.payload,
    isOkGetDMKhachHang: true,
    isProgress: false
  };
};
const Reducer_SaveCustomers = (state, action) => ({
  ...state,
  objData: action.payload,
  disabledKhachHangClick: true,
  isProgress: true,
  isSaveOk: false
});
const Reducer_SaveCustomersSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isSaveOk: true,
    disabledKhachHangClick: false,
    isProgress: false
  };
};
const Reducer_SaveCustomersFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isSaveOk: false,
    disabledKhachHangClick: false,
    isProgress: false
  };
};
const Reducer_DeleteCustomers = (state, action) => ({
  ...state,
  objData: action.payload,
  isProgress: true
});
const Reducer_DeleteCustomersSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false
  };
};
const Reducer_DeleteCustomersFalse = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    isProgress: false
  };
};
const Reducer_GetDMNhomCustomers = (state, action) => {
  return {
    ...state,
    objNhomCustomer: {},
  };
};
const Reducer_GetDMNhomCustomersSuccess = (state, action) => {
  console.log("check the data in reducer", action);
  return {
    ...state,
    objNhomCustomer: action.payload,
  };
};
// end 
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case Action_GetDMCustomers:
      return Reducer_GetDMCustomers(state, action);
    case Action_GetDMCustomersSuccess:
      return Reducer_GetDMCustomersSuccess(state, action);

    case Action_SaveCustomers:
      return Reducer_SaveCustomers(state, action);
    case Action_SaveCustomersSuccess:
      return Reducer_SaveCustomersSuccess(state, action);
    case Action_SaveCustomersFailed:
      return Reducer_SaveCustomersFalse(state, action);

    case Action_DeleteCustomers:
      return Reducer_DeleteCustomers(state, action);
    case Action_DeleteCustomersSuccess:
      return Reducer_DeleteCustomersSuccess(state, action);
    case Action_DeleteCustomersFailed:
      return Reducer_DeleteCustomersFalse(state, action);

    case Action_GetCustomerByIdAndDebt:
      return Reducer_GetCustomerById(state, action);
    case Action_GetCustomerByIdAndDebtSuccess:
      return Reducer_GetCustomerByIdSuccess(state, action);

    case Action_GetDMNhomCustomers:
      return Reducer_GetDMNhomCustomers(state, action);
    case Action_GetDMNhomCustomersSuccess:
      return Reducer_GetDMNhomCustomersSuccess(state, action);


    default:
      return state;
  }
};
export default authReducer;
